var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.query)?_c('iframe',{staticClass:"map w-full",attrs:{"frameborder":"0","src":_vm.googleEmbedUrl}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }